import { useState, useEffect } from "react";
import { getCache, setCache } from "utils/cache";
import { loadLocaleParam } from "utils/locale";
import { loadBrandParam } from "utils/common";

const urlInterceptor = (url) => {
	try {
		url = new URL(`${url}`);
	} catch (e) {
		url = new URL(`${url}`, window.location.origin);
	}
	url.searchParams.append("locale", loadLocaleParam());
	url.searchParams.append("brand", loadBrandParam());
	url = url.href;
	return url;
};

const useFetch = (url, { options, trigger, cacheValidMinutes = 0 }) => {
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		const abortController = new AbortController();
		const signal = abortController.signal;
		const doFetch = async () => {
			setError(null);
			setLoading(true);
			try {
				let res;
				const requestUrl = urlInterceptor(url);
				if (cacheValidMinutes) {
					res = await getCache(requestUrl);
				}
				if (!res) {
					res = await fetch(requestUrl, {
						...options,
						...{ signal },
					});
					if (!res.ok) {
						const errorResponse = {
							body: await res.json(),
							message: res.message || "Request error",
							status: res.status,
							statusText: res.statusText,
							type: res.type,
						};
						throw errorResponse;
					}
					if (cacheValidMinutes) {
						await setCache(requestUrl, res.clone(), cacheValidMinutes);
					}
				}
				const json = await res.json();
				if (!signal.aborted) {
					setResponse(json);
				}
			} catch (e) {
				if (!signal.aborted) {
					setResponse(null);
					setError(e);
				}
			} finally {
				if (!signal.aborted) {
					setLoading(false);
				}
			}
		};
		if (url) {
			doFetch();
		}
		return () => {
			abortController.abort();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [trigger]);
	return { response, error, loading };
};
export default useFetch;
